import { app } from '../../../../../../app';
import { Controller } from './remove-account-from-group.controller';

app.component('companyUserDirectoriesManageAccountGroupsAppsRemoveFromGroups', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./remove-account-from-group.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/groups-apps/remove-from-group/remove-account-from-group.component.js